<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span>REGISTRO ESTIMACIÓN PRESUPUESTARIA</span>

        <div style="max-width: 200px">
          <v-select
            :items="gestiones"
            label="Gestion"
            item-text="numero"
            item-value="id"
            v-model="gestionId"
            @input="setGestionId"
            placeholder=" "
            outlined
            dense
            hide-details />
        </div>
      </div>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" md="9" xl="10" class="pa-2 pb-0">
        <v-btn
          v-if="
            (permisosPresupuestos1 || permisosPresupuestos2) &&
            !permisosPresupuestos3 &&
            gestionId === gestionActual?.id
          "
          small
          color="primary"
          class="mr-2 my-1"
          @click="$refs.modalFormPresupuestoRef.abrir('registrar', [])"
          title="Registrar">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          v-if="
            (permisosPresupuestos1 || permisosPresupuestos2) &&
            !permisosPresupuestos3 &&
            gestionId === gestionActual?.id
          "
          small
          class="mr-2 my-1"
          :disabled="item == null"
          @click="$refs.modalFormPresupuestoRef.abrir('editar', item)"
          title="Editar">
          <v-icon>mdi-pencil</v-icon>

          Editar
        </v-btn>

        <v-btn
          small
          class="mr-2 my-1"
          :disabled="item == null"
          @click="$refs.modalPresupuestoGestionRef.abrir(item, tiposPresupuestos.GASTO)"
          title="Presupuesto Gastos">
          <v-icon>mdi-ballot</v-icon>

          Ppto. Gastos
        </v-btn>

        <v-btn
          small
          class="mr-2 my-1"
          :disabled="item == null"
          @click="$refs.modalPresupuestoGestionRef.abrir(item, tiposPresupuestos.INGRESO)"
          title="Presupuesto Ingresos">
          <v-icon>mdi-ballot</v-icon>

          Ppto. Ingresos
        </v-btn>

        <v-btn
          small
          class="mr-2 my-1"
          :disabled="item == null"
          @click="$refs.modalPresupuestosRef.abrir(item)"
          title="Ver Presupuesto">
          <v-icon>mdi-file-chart</v-icon>

          Ver Presupuesto
        </v-btn>

        <v-btn small class="mr-2 my-1" @click="listar" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2" class="pa-2 pb-0">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-2 pb-6">
        <ListadoPresupuesto ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormPresupuesto
      ref="modalFormPresupuestoRef"
      nombreRecurso="PRESUPUESTO DE GASTOS E INGRESOS"
      @actualizarListado="listar" />

    <ModalPresupuestoGestion ref="modalPresupuestoGestionRef" :tipo="tipo" @cerrar="listar" />

    <VerPdf ref="verPdf" />

    <ModalPresupuestos ref="modalPresupuestosRef" />

    <notifications group="notifications" position="top right" />
  </div>
</template> 

<script>
import VerPdf from '../components/VerPdf.vue';
import ListadoPresupuesto from '../views/ListadoPresupuesto.vue';
import ModalFormPresupuesto from '../components/ModalFormPresupuesto.vue';
import ModalPresupuestoGestion from '../components/ModalPresupuestoGestion.vue';
import ModalPresupuestos from '../components/ModalPresupuestos.vue';
import PresupuestoGastoServices from '../services/index';
import GetGestionesMixin from '../mixins/get-gestiones-mixin';
import LayoutMixin from '../mixins/layout-mixin';
import { TIPOS_PRESUPUESTOS } from '../utils';
import { mapGetters } from 'vuex';

export default {
  name: 'Presupuesto',
  mixins: [GetGestionesMixin, LayoutMixin],
  components: {
    ListadoPresupuesto,
    ModalFormPresupuesto,
    ModalPresupuestoGestion,
    VerPdf,
    ModalPresupuestos,
  },
  data() {
    return {
      servicioListarItems: PresupuestoGastoServices.get,
      nombreRecurso: 'PRESUPUESTO DE GASTOS E INGRESOS',
      tiposPresupuestos: TIPOS_PRESUPUESTOS,
      tipo: TIPOS_PRESUPUESTOS.GASTO,
    };
  },
  computed: {
    ...mapGetters({
      permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosPresupuestos3: 'presupuesto/permisosPresupuestos3',
    }),
    gestionActual() {
      return this.gestiones.find((gestion) => gestion.numero == new Date().getFullYear());
    },
  },
  mounted() {
    this.obtenerGestiones();
  },
  watch: {
    '$store.state.CARGO.sede.id': function (val) {
      if (val && this.gestionId) {
        this.listar();
      }
    },
    'gestion.numero': {
      handler: function (val) {
        if (val && this.$store.state.CARGO.sede.id) {
          this.listar();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async listar() {
      const params = {
        sede_id: this.$store.state.CARGO.sede.id,
        gestion_id: this.gestionId,
      };

      this.listarMixin(params);
    },
    async verPdf(id) {
      try {
        const response = await PresupuestoGastoServices.consolidado(id, this.tipo);
        const pdf = 'data:application/pdf;base64,' + response.data.data + '#toolbar=0';
        this.$refs.verPdf.abrir(pdf);
      } catch (err) {
        window.console.log(err);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>
    